import { ProjectWizardContext } from 'context/Context';
import { Formik, Form as FormikForm } from 'formik';
import lodash from 'lodash';
import { useContext, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';
import { getRealEstateByUserId } from 'redux/realEstateSlice';
import { ShareData } from 'sites/admin/inmobiliario/gestionarPropiedades/propertyWizard/steps/components/ShareData';
import { Description } from 'sites/admin/inmobiliario/gestionarPropiedades/propertyWizard/steps/components/inputs/Description';
import messageHandler from 'utils/messageHandler';
import { ProjectDataSchema } from '../../validations/projectsValidation';
import { BuilderData } from './components/BuilderData';
import { ProjectData } from './components/ProjectData';

const Emprendimiento = () => {
  const { data, handleSubmit, setStepStatus, yupSubmitRef } =
    useContext(ProjectWizardContext);

  const dispatch = useDispatch();

  const userLogged = useSelector(state => state.login.currentUser);
  const realEstate = useSelector(state => state.realEstate.realEstate);

  useEffect(() => {
    userLogged?.id && dispatch(getRealEstateByUserId(userLogged.id));
  }, [userLogged]);

  const initialValues = {
    description: data.description || '',
    real_estate_id: data.real_estate_id || realEstate.id,
    branch_office_id: data.branch_office_id || '',
    title: data.title || '',
    share: data.share?.percent ? String(data.share.percent) : '',
    builder: {
      name: data.builder?.name || '',
      deadline: data.builder?.deadline || '',
      project_status: data.builder?.project_status || '',
      observations: data.builder?.observations || ''
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={ProjectDataSchema}
      onSubmit={values => {
        handleSubmit(values, lodash.isEqual(values, initialValues));
      }}
    >
      {({ errors, touched, values, setValues }) => {
        useEffect(() => {
          setValues(prev => ({
            ...prev,
            real_estate_id: data.real_estate_id || realEstate.id
          }));
        }, [realEstate]);

        useEffect(() => {
          setStepStatus(prev => ({
            ...prev,
            ...values
          }));
        }, [values]);

        return (
          <>
            <FormikForm
              className="mb-3"
              onKeyPress={e => {
                e.key === 'Enter' && e.preventDefault();
              }}
            >
              <Row>
                <Col md={12} className="px-0 px-md-3 ">
                  <legend>
                    <FiCheck /> Describa el emprendimiento.
                  </legend>

                  <Row className="g-3 mb-4">
                    <ProjectData
                      data={data}
                      errors={errors}
                      touched={touched}
                      setValues={setValues}
                      values={values}
                      realEstate={realEstate}
                    />
                  </Row>
                </Col>

                <Col md={12} xs={12} className="bg-light px-0 px-md-3">
                  <Row className="g-3">
                    <BuilderData
                      errors={errors}
                      touched={touched}
                      values={values}
                      setValues={setValues}
                    />
                  </Row>
                </Col>
              </Row>
              <Row className="mt-4 mb-5">
                <Col xs={12} className="px-0 px-md-3">
                  <ShareData />
                </Col>
                <Col xs={12} className="mt-3 px-0 px-md-3">
                  <Description errors={errors} touched={touched} />
                </Col>
              </Row>

              <button
                onClick={() =>
                  Object.keys(errors).length &&
                  messageHandler(
                    'error',
                    'Uno o más campos son incorrectos. Por favor, corrija los errores para poder continuar.'
                  )
                }
                hidden
                ref={yupSubmitRef}
              ></button>
            </FormikForm>
          </>
        );
      }}
    </Formik>
  );
};

export default Emprendimiento;
